'use client'

// --- Tiptap Core Extensions ---
// --- Icons ---
import { Editor } from '@tiptap/react'
// --- Tiptap UI Primitives ---
import {
  Toolbar,
  ToolbarGroup,
  ToolbarSeparator,
} from '@/tiptap/tiptap-ui-primitive/toolbar'
// --- Tiptap UI ---
import { BlockquoteButton } from '@/tiptap/tiptap-ui/blockquote-button'
import { CodeBlockButton } from '@/tiptap/tiptap-ui/code-block-button'
import { HeadingDropdownMenu } from '@/tiptap/tiptap-ui/heading-dropdown-menu'
import { ImageUploadButton } from '@/tiptap/tiptap-ui/image-upload-button'
import { ListDropdownMenu } from '@/tiptap/tiptap-ui/list-dropdown-menu'
import { MarkButton } from '@/tiptap/tiptap-ui/mark-button'
import { TextAlignButton } from '@/tiptap/tiptap-ui/text-align-button'
import { UndoRedoButton } from '@/tiptap/tiptap-ui/undo-redo-button'


export const MainToolbar = ({ editor }: { editor: Editor }) => {
  return (
    <Toolbar>
      <ToolbarGroup>
        <UndoRedoButton action='undo' />
        <UndoRedoButton action='redo' />
      </ToolbarGroup>

      <ToolbarSeparator />

      <ToolbarGroup>
        <HeadingDropdownMenu levels={[1, 2, 3, 4]} />
        <ListDropdownMenu types={['bulletList', 'orderedList', 'taskList']} />
        <BlockquoteButton />
        <CodeBlockButton />
      </ToolbarGroup>

      <ToolbarSeparator />

      <ToolbarGroup>
        <MarkButton type='bold' />
        <MarkButton type='italic' />
        <MarkButton type='strike' />
        <MarkButton type='code' />
        <MarkButton type='underline' />
      </ToolbarGroup>

      <ToolbarSeparator />

      <ToolbarGroup>
        <TextAlignButton align='left' />
        <TextAlignButton align='center' />
        <TextAlignButton align='right' />
        <TextAlignButton align='justify' />
      </ToolbarGroup>

      <ToolbarSeparator />

      <ToolbarGroup>
        <ImageUploadButton text='Image' />
      </ToolbarGroup>

    </Toolbar>
  )
}

